let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eYatm")).then(() => parcelRequire('2Z71B'));